import { chunks, chunkMapping } from "#blokkli-build/imports";
import { defineAsyncComponent } from "#imports";
function objectOrImport(key) {
  const chunkName = chunkMapping[key];
  if (!chunkName) {
    return;
  }
  const chunkEntry = chunks[chunkName];
  if (!chunkEntry) {
    return;
  }
  if (typeof chunkEntry === "function") {
    return defineAsyncComponent(
      () => chunkEntry().then((group) => {
        const item2 = group[key];
        if (item2 && "loadComponent" in item2) {
          return item2.loadComponent();
        }
        return item2;
      })
    );
  }
  const item = chunkEntry[key];
  if (item && "loadComponent" in item) {
    return defineAsyncComponent(() => item.loadComponent());
  }
  return item;
}
export function getComponent(type, bundle, fieldListType, parentBundle) {
  if (fieldListType) {
    const key2 = `${type}:${bundle}__f:${fieldListType}`;
    if (chunkMapping[key2]) {
      return objectOrImport(key2);
    }
  }
  if (parentBundle) {
    const key2 = `${type}:${bundle}__p:${parentBundle}`;
    if (chunkMapping[key2]) {
      return objectOrImport(key2);
    }
  }
  const key = `${type}:${bundle}`;
  return objectOrImport(key);
}
